require('./cardLastMovementsTable.scss');

const PropTypes = require('prop-types');

const React = require('react');
const { connect } = require('react-redux');

const { FormattedText, getLanguage } = require('core/i18n').i18n;

const CardLastMovementsTableRow = require('components/cards/cardLastMovements/cardLastMovementsTableRow/cardLastMovementsTableRow');
const { LastMovementsTable } = require('commonsComponents/lastMovementsTable');
const CardLastMovementsMoreInfoRow = require('components/cards/cardLastMovements/cardLastMovementsMoreInfoRow/cardLastMovementsMoreInfoRow');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
const { CategoriesModal } = require('components/commons/categoriesModal/categoriesModal');
const { CategoriesModalOld } = require('components/commons/categoriesModal/categoriesModalOld');
import FeatureTogglingRender from 'components/conditionalRender/featureTogglingRender';
const { LAVANDA, PFM, PFM_NEW_FEATURES } = require('constants/flagBasedFeatures');

// @ helpers
const { recordLink } = require('utilities/tagging');
const { cardValidationRules } = require('utilities/accessHelperConditions/cards');

//@constants
const { CARD_CREDIT, CARD_DEFERRABLE_PAYMENT } = require('constants/index');
const { LAST_MOVEMENTS_TABLE_CURRENT_MONTH_KEY } = require('constants/commonsComponents');
const { ACTION_EVENT_VIEW, DEFERRAL_PAYMENT_CARD_ACTION_EVENT } = require('constants/tagging');
class cardLastMovementsTable extends React.Component {
    constructor(props){
        super(props);

        this.state = {
            expandedRowId: ''
        };

        this.handleRowClick = this.handleRowClick.bind(this);
    }

    componentDidMount(){
        const { immTransactions } = this.props;

        this.recordTagAppearence(immTransactions.get('byId'));
    }

    componentWillReceiveProps(nextProps){
        const { immTransactions } = this.props;
        const { immTransactions: immNextTransactions } = nextProps;

        if (immTransactions.get('byId').size !== immNextTransactions.get('byId').size) {
            const transactions = immNextTransactions.get('byId').filterNot(t => immTransactions.get('byId').contains(t));
            this.recordTagAppearence(transactions);
        }
    }


    recordTagAppearence(transactions){
        const { immCard, lavandaEnabled } = this.props;

        if (cardValidationRules.CARD_PAYMENT_PURCHASE_DEFERRAL.validator({ immCard })){
            const atLeastOneDeferralPayment = transactions.some(transaction => transaction.get('deferPaymentIndicator') === CARD_DEFERRABLE_PAYMENT);
            lavandaEnabled && atLeastOneDeferralPayment && recordLink(window.utag_last_name, DEFERRAL_PAYMENT_CARD_ACTION_EVENT, ACTION_EVENT_VIEW);
        }
    }

    handleRowClick(rowId) {
        // If a click a expanded row, I must collapse it
        this.setState(function(previousState){
            return { expandedRowId: (rowId === previousState.expandedRowId) ? '' : rowId }
        })
    }

    render() {
        const { immTransactions, immCard, defaultLanguage, pfmNewFeatures } = this.props;
        const language = getLanguage(defaultLanguage);
        let table = <div></div>;

        if (immTransactions){
            const immMovementsByOrder = immTransactions.get('byOrder');
            const immMovementsById = immTransactions.get('byId');
            const categoryFormattedText = (//Don't remove the span tag it fix a bug with the tooltip
                <span>
                    <FormattedText value="myMoneyTransactions-category" format="firstUppercase" />
                </span>
            );
            const categoryTooltip =(
                <OKTooltip
                    content="myMoneyTransactions-categoryTooltip"
                    offset={[0, -15]}
                    target={categoryFormattedText}
                    type="descriptive"
                />
            );
            const dateFormattedText = (
                <span>
                    <FormattedText value="cardsTransactions-date" format="firstUppercase" />
                </span>
            );
            let purchaseDeferralColumn;
            let columnsCount = 5;


            if (immCard.get('type') === CARD_CREDIT) {
                columnsCount = 6;
                purchaseDeferralColumn = (
                    <OKTableCell asHeader={true} className="card-last-movements-table__cell-header--deferrable">
                        <FormattedText value="cardsTransactions-deferredPurchases" format="firstUppercase" />
                    </OKTableCell>
                );
            }

            table = (
                <div>
                    {
                        pfmNewFeatures ?
                            <CategoriesModal />
                        :
                            <CategoriesModalOld byCategory />
                    }
                    <LastMovementsTable
                        groupByDate={true}
                        rowComponent={CardLastMovementsTableRow}
                        immTransactionsByOrder={immMovementsByOrder}
                        immTransactionsById={immMovementsById}
                        columnsCount={columnsCount}
                        groupHeaderClassName={'card-last-movements-table__group-header'}
                        expandedRowId={this.state.expandedRowId}
                        expandedRowComponent={CardLastMovementsMoreInfoRow}
                        onRowClick={this.handleRowClick}
                        id={'card-last-movements'}
                        currentMonthKey={LAST_MOVEMENTS_TABLE_CURRENT_MONTH_KEY}
                        language={language}
                    >
                        <thead>
                            <OKTableRow asHeader={true}>
                                <OKTableCell asHeader={true} className="card-last-movements-table__cell-header--expand">
                                    <span></span>
                                </OKTableCell>
                                <OKTableCell asHeader={true} className="card-last-movements-table__cell-header--date">
                                    <OKTooltip
                                        content="cardsTransactions-dateTooltip"
                                        offset={[0, -15]}
                                        target={dateFormattedText}
                                        type="descriptive"
                                    />
                                </OKTableCell>
                                <FeatureTogglingRender notAllowedProductKey={PFM} >
                                    <OKTableCell asHeader={true} className="text-center">
                                        {categoryTooltip}
                                    </OKTableCell>
                                </FeatureTogglingRender>
                                <OKTableCell asHeader={true}>
                                    <FormattedText value="cardsTransactions-description" format="firstUppercase" />
                                </OKTableCell>
                                <OKTableCell asHeader={true} className="card-last-movements-table__cell-header--status">
                                    <FormattedText value="cardsTransactions-status" format="firstUppercase" />
                                </OKTableCell>
                                {purchaseDeferralColumn}
                                <OKTableCell asHeader={true} className="card-last-movements-table__cell-header--import">
                                    <FormattedText value="cardsTransactions-amount" format="firstUppercase" />
                                </OKTableCell>
                            </OKTableRow>
                        </thead>
                    </LastMovementsTable>
                </div>
            )
        }
        return table;
    }
}

cardLastMovementsTable.propTypes = {
    defaultLanguage: PropTypes.string,
    immTransactions: PropTypes.object,
    immCard: PropTypes.object,
    lavandaEnabled: PropTypes.bool,
    pfmNewFeatures: PropTypes.bool
};

module.exports = cardLastMovementsTable;

module.exports = connect(state => ({
    lavandaEnabled: state.flagBasedFeatures.get(LAVANDA),
    pfmNewFeatures: state.flagBasedFeatures.get(PFM_NEW_FEATURES),
}), {})(cardLastMovementsTable);
